import { getCurrencySymbol } from '../currency/getCurrencySymbol'

export const customValueFormatter = (params) => {
  return params?.value ?? 'NA'
}

export const customCurrencyValueFormatter = (params) => {
  if (params.value == null) return 'NA'
  const symbol = params.data.currency_code ? getCurrencySymbol(params.data.currency_code) : '$'
  return `${symbol} ${parseFloat(params.value).toFixed(2)}`
}

export const formatNumber = (num, currencySymbol = '', fixDec = 2) => {
  if (typeof num !== 'number') return num

  const roundValue = (val, precision) => {
    const factor = Math.pow(10, precision)
    return Math.round(val * factor) / factor
  }

  const prefix = currencySymbol || ''

  if (num === 0) {
    return `<${prefix}0.01`
  } else if (Math.abs(num) < 1 && Math.abs(num) >= 0.01) {
    const roundedValue = Math.round(num * 100) / 100
    if (roundedValue >= 1) {
      return `${prefix}1`
    }
    return `${prefix}${roundedValue.toFixed(fixDec)}`
  } else if (num < 0.01 && num > -0.01) {
    return num > 0 ? `<${prefix}0.01` : `>${prefix}-0.01`
  }

  if (num > 0 && num < 1) {
    return `${prefix}${roundValue(num, fixDec)}`
  }

  if (num >= 1 && num < 1_000) {
    return num % 1 === 0 ? `${prefix}${num}` : `${prefix}${num.toFixed(2)}`
  }

  if (num >= 1_000 && num < 1_000_000) {
    if (num < 10_000) {
      return `${prefix}${Math.floor(num)}`
    } else if (num < 100_000) {
      return `${prefix}${roundValue(num / 1_000, 1)}K`
    } else {
      return `${prefix}${roundValue(num / 1_000, 1)}K`
    }
  }

  if (num >= 1_000_000 && num < 1_000_000_000) {
    if (num < 10_000_000) {
      return `${prefix}${roundValue(num / 1_000_000, 2)}M`
    } else if (num < 100_000_000) {
      return `${prefix}${roundValue(num / 1_000_000, 1)}M`
    } else {
      return `${prefix}${Math.floor(num / 1_000_000)}M`
    }
  }

  if (num >= 1_000_000_000 && num < 1_000_000_000_000) {
    if (num < 10_000_000_000) {
      return `${prefix}${roundValue(num / 1_000_000_000, 2)}B`
    } else if (num < 100_000_000_000) {
      return `${prefix}${roundValue(num / 1_000_000_000, 1)}B`
    } else {
      return `${prefix}${Math.floor(num / 1_000_000_000)}B`
    }
  }

  if (num >= 1_000_000_000_000) {
    if (num < 10_000_000_000_000) {
      return `${prefix}${roundValue(num / 1_000_000_000_000, 2)}T`
    } else if (num < 100_000_000_000_000) {
      return `${prefix}${roundValue(num / 1_000_000_000_000, 1)}T`
    } else {
      return `${prefix}${Math.floor(num / 1_000_000_000_000)}T`
    }
  }

  return `${prefix}${roundValue(num, fixDec)}`
}
